import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as firebase from 'firebase';
import Card from 'material-ui/Card';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';

<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
/**
 * Receives sessionid and uid props from simulationContainer
 *
 * this component acts as the simulationContainer for all
 * components in the actual orderbook.
 */
class DealerControls extends Component {
    constructor(props) {
        //console.log("OrderbookContainer created");
        super(props);
    }

    componentDidMount() {

    }

    componentWillUnmount() {
    }

    /**
     * Conditionally renders limit orders based on state.ready
     * @returns {*}
     */

    render() {
        //console.log("OrderbookContainer render");
        //console.log(this.state.userSums);
    
        return (

          <span>
              <button type = "button" className="control negative button-dealer-red" disabled={this.props.contdisb} onClick={()=>{this.props.contclick('-', this.props.type)}}>-</button>
              <button type = "button" className="control positive button-dealer-green" disabled={this.props.contdisb} onClick={()=>{this.props.contclick('+', this.props.type)}}>+</button>
          </span>

        );

    }
}

export default DealerControls;



// WEBPACK FOOTER //
// ./src/components/Orderbook/DealerControls.js